<template>
    <div class="list-profile-item">
        <div class="list-profile-item__inner">
            <WatsonAtomImage
                v-if="picture"
                :content="picture"
                class="list-profile-item__image"
                dimension="none"
            />

            <div
                v-else
                class="list-profile-item__image list-profile-item__image--placeholder"
            ></div>

            <component
                :is="url ? 'a' : 'div'"
                class="list-profile-item__title"
                :href="url"
            >
                <WatsonAtomDynamicText
                    v-if="title"
                    :text="title"
                    :typography="typography.profileTitle"
                    class="list-profile-item__title-inner"
                />
            </component>

            <div class="list-profile-item__description">
                <WatsonAtomDynamicText
                    v-if="description"
                    :text="stripHtml(description)"
                    :typography="typography.profileDescription"
                    class="list-profile-item__text"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import WatsonAtomDynamicText from '@atoms/dynamic-text/watson-atom-dynamic-text.vue';
import WatsonAtomImage from '@atoms/image/watson-atom-image.vue';

import stripHtml from '@utils/strip-html';

defineProps({
    url: {
        type: String,
        required: false,
        default: '',
    },
    picture: {
        type: [Object, Boolean],
        required: false,
        default: () => ({}),
    },
    title: {
        type: String,
        required: false,
        default: '',
    },
    description: {
        type: String,
        required: false,
        default: '',
    },
    typography: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});
</script>

<style lang="scss">
@use 'watson-theme-list-profile-item';
</style>
